import { Field } from "./FieldHelpers";
import { TranslationService } from "../../../../services/TranslationService";
import { MultiFileUpload } from "../../../shared/components/MultiFileUpload";
import { EditProps } from "../EditAction";

export const FilesUpload = ({ setField, data }: EditProps) => {
  const onFilesChange = (vals: any) => {
    setField("files")(vals?.map((f: any) => ({ id: f.id, fileName: f.name })));
  };
  return (
    <Field title={TranslationService.translate.AttachFile}>
      <MultiFileUpload
        canEdit
        onFilesChange={onFilesChange}
        files={data.files?.map((f: any) => ({ id: f.id, name: f.fileName }))}
      />
    </Field>
  );
};
